import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { QuestionWithResponse, SaveSurveyResponse } from '../models/survey-response.model';

@Injectable({
  providedIn: 'root'
})
export class SurveyResponseService {
  private baseUrl = 'SurveyResponse';

  constructor(private http: HttpClient) { }

  getSurveyQuestions(surveyTypeId: number): Observable<ApiResponse<QuestionWithResponse[]>> {
    return this.http.get<ApiResponse<QuestionWithResponse[]>>(`${this.baseUrl}/${surveyTypeId}`);
  }

  saveResponses(payload: SaveSurveyResponse): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.baseUrl}/Save`, payload);
  }
}

